<template>
    <v-layout row wrap v-if="profileImage">
        <v-flex xs12 class="relative-position">
            <div class="post__progress" v-if="saveInProgress">
                <v-progress-circular indeterminate color="ypo_blue"></v-progress-circular>
            </div>
            <v-layout
                class="post"
                :id="chapterPost.parentPostId ? 'comment_activation_div' : 'post_activation_div'"
                :data-qe-id="chapterPost.parentPostId ? 'comment_activation_div' : 'post_activation_div'"
                @click="openPostDialog()"
                v-if="showSharePost && (!isAllNetworks || showCommentsForAllNetworks) && !showPostDialogue"
                align-center
            >
                <span class="post__placeholder">{{ placeHolderText }} {{ placeholderType }} </span>
                <v-spacer></v-spacer>
                <v-btn
                    depressed
                    class="primary_btn hidden-xs"
                    :data-qe-id="chapterPost.parentPostId ? 'add_comment_submit_button' : 'add_comment_submit_button'"
                    id="post_btn_submit"
                    >{{ submitBtnText }}
                </v-btn>
                <span class="visible-xs share__post"> <i class="fas fa-share" id="post_btn_icon"></i></span>
            </v-layout>
            <v-layout
                class="post network-post"
                :id="chapterPost.parentPostId ? 'comment_activation_div' : 'post_activation_div'"
                :data-qe-id="chapterPost.parentPostId ? 'comment_activation_div' : 'post_activation_div'"
                v-if="!showPostDialogue && showPostActivatorBox && isAllNetworks && !parentId"
                align-center
            >
                <v-flex pr-2 pl-3 class="hidden-xs">
                    {{ placeHolderText }}
                </v-flex>
                <v-flex v-if="usersCommunitiesList && usersCommunitiesList.length > 1" ml-3>
                    <v-select
                        data-qe-id="add_post_select_network_drop-down"
                        :items="networkOptions()"
                        item-text="name"
                        id="network_options_unit_test"
                        return-object
                        v-model="currentNetwork"
                        color="ypo_cta"
                        class="network-selector"
                        :placeholder="communityCommonConstant.post.SELECT_NETWORK"
                        @change="openPostDialog()"
                    ></v-select>
                </v-flex>
                <v-flex></v-flex>
                <span class="post__placeholder">
                    <span v-if="usersCommunitiesList && usersCommunitiesList.length > 1"> </span>
                    <span v-else> </span>
                </span>
                <v-spacer></v-spacer>
                <v-btn
                    depressed
                    class="primary_btn"
                    id="post_btn"
                    data-qe-id="open_new_post_create_btn"
                    :disabled="!currentNetwork"
                    @click="openPostDialog()"
                    >{{ submitBtnText }}</v-btn>
            </v-layout>
            <transition name="fade">
                <v-layout
                    column
                    class="post post-expand-block"
                    :class="[postError ? 'post-block-error' : '']"
                    id="post_activation_expand_div"
                    data-qe-id="post_activation_expand_div"
                    v-if="showPostDialogue" >
                    <v-layout row class="post__header">
                        <v-flex class="post__avatar">
                            <v-avatar>
                            <img
                                :src="profileImage.originalImage"
                                :onerror="imageErrorFallback(profileImage.fallBackImage)"
                                :alt="profileImage.userName"
                            />
                            </v-avatar>
                        </v-flex>
                    </v-layout>

                    <v-flex xs12 class="post-expand-block__post-title" v-if="!parentId">
                        <v-text-field
                            :label="communityCommonConstant.post.POST_TITLE"
                            v-model="chapterPost.title"
                            solo
                            data-qe-id="`add_post_title`">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-card-text class="pa-0 post-expand-block-details">
                            <v-layout column>
                                <v-flex
                                    xs12
                                    v-if="
                                        usersCommunitiesList &&
                                            usersCommunitiesList.length > 1 &&
                                            isAllNetworks &&
                                            !parentId
                                    "
                                >
                                    <v-layout class="network-post">
                                        <v-flex pl-3 pt-4 pr-2 class="hidden-xs">
                                            {{ communityCommonConstant.post.SHARING_TO_NETWORK_LABEL }}
                                        </v-flex>
                                        <v-flex px-2>
                                            <v-select
                                                data-qe-id="network_post_type_drop-down"
                                                :items="networkOptions()"
                                                item-text="name"
                                                v-model="currentNetwork"
                                                color="ypo_cta"
                                                class="network-selector" ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex sm12 pa-2>
                                    <div class="post__BodyText">
                                        <member-mention-text-area
                                            v-if="!parentId"
                                            editor-id="memberMentionText"
                                            data-qe-id="post_with_member_mentions-text-area"
                                            v-model="chapterPost.body"
                                        >
                                        </member-mention-text-area>
                                        <v-textarea
                                            v-else
                                            auto-grow
                                            rows="1"
                                            id="post_body_input1"
                                            data-qe-id="comment_text_area"
                                            autofocus
                                            outline
                                            single-line
                                            scrollable
                                            v-model="chapterPost.body"
                                            :placeholder="placeHolderText"></v-textarea>
                                    </div>
                                    <photo-review
                                        v-if="canUploadImage"
                                        :photo-list="files"
                                        :can-add-more="showPhotoUploader"
                                        :number-of-files-allowed="communityCommonConstant.post.MAXIMUM_NUMBER_OF_POST_IMAGE"
                                        :add-more-photos-handler="handleUploadedFiles"
                                        :remove-photo-handler="removeFileFromUploader"
                                        :fileSizeFromOtherSources="alreadyUploadedFilesSize"
                                        :maxFileSizeLimit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT" >
                                    </photo-review>
                                    <file-attachment
                                        v-if="canUploadImage"
                                        attachmentId="post_file_attachment"
                                        :attachmentCallback="handleAttachedFiles"
                                        :fileSizeFromOtherSources="postImageFileSize"
                                        :maxFilesToAttach="appCommonConstants.MAXIMUM_NUMBER_OF_FILE_ATTACHMENTS"
                                        :maxFileSizeLimit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT"></file-attachment>
                                </v-flex>
                                <v-flex v-if="isNetworkPage && !parentId" class="post__content">
                                    <div class="content-message">
                                        <span class="content-message__icon">
                                            <i class="fa fa-question" aria-hidden="true"></i>
                                        </span>
                                        <div class="content-message__text">
                                            <span v-html="communityCommonConstant.REMINDER_MESSAGE_HTML"></span>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex sm12>
                                    <v-layout row class="post__Allow_Comments">
                                        <v-flex xs5 sm4 class="btns_block">
                                            <v-flex v-if="canUploadImage && showPhotoUploader" pl-2>
                                                <photo-uploader
                                                    uploader-id="post_photo_uploader_btn"
                                                    data-qe-id="post_photo_uploader_btn"
                                                    :multiple="true"
                                                    :maximum-files="
                                                        communityCommonConstant.post.MAXIMUM_NUMBER_OF_POST_IMAGE
                                                    "
                                                    :alreadyAddedImages="files"
                                                    :is-type-button="true"
                                                    :upload-callback="handleUploadedFiles"
                                                    :file-size-from-other-sources="alreadyUploadedFilesSize"
                                                    :max-file-size-limit="appCommonConstants.FILE_ATTACHMENT_SIZE_LIMIT"
                                                >
                                                </photo-uploader>
                                            </v-flex>
                                        </v-flex>

                                        <v-flex xs7 sm8 text-xs-right>
                                            <span class="post__Allow_Comments__check" v-if="showAllowCommentOption">
                                                <v-checkbox
                                                    class="text-xs-right"
                                                    color="ypo_blue"
                                                    id="allow_comment_checkbox"
                                                    data-qe-id="allow_comment_checkbox"
                                                    :label="communityCommonConstant.post.ALLOW_COMMENTS"
                                                    v-model="chapterPost.canComment" ></v-checkbox>
                                            </span>

                                            <v-btn
                                                flat
                                                small
                                                id="cancel_post_btn"
                                                class="bold-font"
                                                data-qe-id="cancel_new_post_btn"
                                                :disabled="saveInProgress"
                                                @click="closePostDialog()">
                                                {{communityCommonConstant.post.CANCEL}}
                                            </v-btn>

                                            <v-btn
                                                id="dialog_post_btn"
                                                data-qe-id="submit_new_post_btn"
                                                @click="postNewActivity()"
                                                class="primary_btn small" >
                                                {{ submitBtnText }}
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-flex>
                    <div class="post_activation_expand_div" @click.capture="handleCommentShow()"></div>
                </v-layout>
            </transition>
        </v-flex>
    </v-layout>
</template>

<script>
import { communityCommonConstant } from '../communityCommon.constant';
import { activityPostObject } from '../../../store/store.constant';
import { createFormDataForSelectedFiles, prepareTempImagesForSave } from '../../../common/utils/fileUploader';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { storeAction } from '../../../store/storeActions.constant';
import { storeMutation } from '../../../store/storeMutations.constant';
import { storeGetters } from '../../../store/storeGetters.constant';
import FileUpload from 'vue-upload-component';
import StatusBar from '../../StatusBar/StatusBar';
import MemberMentionTextArea from '../../CkEditor/MemberMentionTextArea';
import PhotoUploader from '../../PhotoUploader/PhotoUploader';
import uniqBy from 'lodash/uniqBy';
import PhotoReview from '../../PhotoUploader/PhotoReview';
import { appCommonConstants, routerNames } from '../../appCommon.constants';
import FileAttachment from '../FileAttachment/FileAttachment';
import { imageErrorFallback } from '../../../common/utils/utils';
import { getHbRedirectByCommunityId } from "@/common/utils/hivebriteUtils";
import { trackActivityPostData } from "@/plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";
import { myToolsConstants } from '../../Tools/mytools.constant';
import sortBy from "lodash/sortBy";

export default {
    name: 'AddPost',
    components: {
        PhotoReview,
        PhotoUploader,
        FileUpload,
        StatusBar,
        MemberMentionTextArea,
        FileAttachment,
    },
    created() {
        this.showPostDialogue = this.showPostBoxOnLoad;
    },
    mounted() {
        if (!this.$route.query.commentId && this.$route.query.isReplyOpen === this.communityCommonConstant.TRUE) {
            this.openPostDialog();
        }
    },
    props: {
        canUploadImage: {
            type: Boolean,
            default: true,
        },
        submitBtnText: {
            type: String,
            default: communityCommonConstant.post.SHARE,
        },
        showAllowCommentOption: {
            type: Boolean,
            default: true,
        },
        placeHolderText: {
            type: String,
            default: communityCommonConstant.post.SHARE_SOMETHING,
        },
        parentId: {
            type: String,
            default: '',
        },
        showCommentsForAllNetworks: {
            type: Boolean,
            default: false,
        },
        commentCountValue: {
            type: Number,
            default: 0,
        },
        showPostActivatorBox: {
            type: Boolean,
            default: true,
        },
        showCommentPlaceholder: {
            type: Boolean,
            default: false,
        },
        handleCloseForParent: {
            type: Function,
        },
        showPostBoxOnLoad: {
            type: Boolean,
            default: false,
        },
    },
    data: () => {
        return {
            files: [],
            communityCommonConstant,
            chapterPost: activityPostObject(),
            postError: false,
            showPostDialogue: false,
            saveInProgress: false,
            attachments: [],
            appCommonConstants,
        };
    },
    methods: {
        ...mapActions({
            createActivityPost: `chapter/${storeAction.createActivityPost}`,
            uploadFilesToTemporaryStorage: `chapter/${storeAction.uploadFilesToTemporaryStorage}`,
        }),
        ...mapMutations({
            setSelectedNetwork: `network/${storeMutation.setSelectedNetwork}`,
        }),
        networkOptions() {
            return sortBy(this.usersCommunitiesList
                .filter(o => o.communityType.toLowerCase() === routerNames.NETWORK.toLowerCase()
                    && o.name.toLowerCase() !== myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE && !getHbRedirectByCommunityId(this.connectPlusRedirects, o.communityId)),
                ['name']);
        },
        openPostDialog() {
            this.chapterPost.body = '';
            this.postError = false;
            this.showPostDialogue = true;
            this.files = [];
            this.attachments = [];
        },
        handleCommentShow() {
            if (!this.isPostActive()) {
                this.closePostDialog();
            }
        },
        closePostDialog() {
            this.saveInProgress = false;
            this.chapterPost = activityPostObject();
            this.showPostDialogue = false;
            this.postError = false;
            if (this.handleCloseForParent) {
                this.handleCloseForParent();
            }
            if (this.addPostAction.failed) {
                this.addPostAction.reset();
            }
        },
        isPostActive() {
            if (this.chapterPost &&
            ((this.chapterPost.body && this.chapterPost.body.length > 0)
            || (this.chapterPost.title && this.chapterPost.title.length > 0)
            || this.files.length > 0 || this.attachments.length > 0)) {
                return true;
            }
        },
        validatePostBody(body) {
            const div = document.createElement('div');
            div.innerHTML = body;
            const bodyText = div.innerText;
            return bodyText && bodyText.replace('&nbsp;', '').trim().length > 0;
        },
        postNewActivity() {
            if (this.validatePostBody(this.chapterPost.body) || this.files.length > 0 || this.attachments.length > 0) {
                this.saveInProgress = true;
                const userMentionPattern = /<a id="(.*?)"/g;
                const guidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i;
                const matches = this.chapterPost.body.match(userMentionPattern);
                this.chapterPost.mentions = [];
                if (matches) {
                    matches.forEach((element) => {
                        const obj = {};
                        const [, cid] = element.match(/id="([^"]*)/);
                        if (guidPattern.test(cid)) {
                            obj.PersonId = cid;
                            const newObj = Object.assign({}, obj);
                            this.chapterPost.mentions.push(newObj);
                        }
                    });
                }

                this.chapterPost.parentPostId = '';

                const communityIdResolved = this.$store.getters[storeGetters.communityIdPromise].then((communityId) => {
                    this.chapterPost.communityId =
                        this.isAllNetworks && this.selectedNetwork ? this.selectedNetwork.communityId : communityId;
                });
                let imageAcquired = Promise.resolve();
                if (this.files.length > 0) {
                    const selectedFiles = createFormDataForSelectedFiles([...this.files]);
                    const uploadData = {
                        selectedNetworkId:
                            this.selectedNetwork && this.selectedNetwork.communityId
                                ? this.selectedNetwork.communityId
                                : '',
                        selectedFiles,
                    };
                    imageAcquired = this.uploadFilesToTemporaryStorage(uploadData).then((resp) => {
                        if (resp) {
                            this.chapterPost.postImage = prepareTempImagesForSave(resp);
                        }
                    });
                }
                let attachmentAcquired = Promise.resolve();
                if (this.attachments.length > 0) {
                    const selectedAttachment = createFormDataForSelectedFiles(this.attachments);
                    const uploadAttachment = {
                        selectedNetworkId:
                            this.selectedNetwork && this.selectedNetwork.communityId
                                ? this.selectedNetwork.communityId
                                : '',
                        selectedFiles: selectedAttachment,
                    };
                    attachmentAcquired = this.uploadFilesToTemporaryStorage(uploadAttachment).then((resp) => {
                        if (resp) {
                            this.chapterPost.postAttachment = prepareTempImagesForSave(resp);
                        }
                    });
                }
                if (this.parentId) {
                    this.chapterPost.body = this.chapterPost.body.replace(/↵/g, '\n').replace(/\n/g, "<br/>");
                }
                this.chapterPost.parentPostId = this.parentId;
                Promise.all([communityIdResolved, imageAcquired, attachmentAcquired])
                    .then(async () => {
                        if (this.chapterPost && this.chapterPost.postImage && this.chapterPost.postImage.length > 0) {
                            let order = 1;
                            this.chapterPost.postImage.forEach((image) => {
                                image.order = order;
                                order += 1;
                            });
                        }
                        if (this.chapterPost && this.chapterPost.postAttachment && this.chapterPost.postAttachment.length > 0) {
                            let order = 1;
                            this.chapterPost.postAttachment.forEach((attachment) => {
                                attachment.order = order;
                                order += 1;
                            });
                        }
                        const postData = await this.createActivityPost(this.chapterPost);
                        let postEventNameForTracking = this.$route.name === routerNames.HOME ?
                            gtmEventName.C_HomePage_Post
                            : gtmEventName.C_Community_Post;
                      if (postData.parentPostId) {
                        postEventNameForTracking = gtmEventName.C_Post_Comment;
                      }
                      trackActivityPostData(postEventNameForTracking, postData);
                    })
                    .then(() => {
                      this.closePostDialog();
                    })
                    .catch(() => {
                        this.saveInProgress = false;
                    });
            } else {
                this.postError = true;
                setTimeout(() => {
                    this.postError = false;
                }, 1000);
                return false;
            }
        },

        handleUploadedFiles(selectedFiles) {
            if (selectedFiles && selectedFiles.length) {
                const newFiles = [...this.files, ...selectedFiles];
                //removing any duplicates
                this.files = uniqBy(newFiles, 'name');
            }
        },
        handleAttachedFiles(attachedFiles) {
            if (attachedFiles) {
                this.attachments = uniqBy(attachedFiles, 'name');
            }
        },
        removeFileFromUploader(fileIndex) {
            this.files.splice(fileIndex, 1);
        },
        imageErrorFallback,
    },
    computed: {
        ...mapState('actionState', ['actions']),
        ...mapGetters({
            usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
            profileImage: `myAccount/${storeGetters.profileImage}`,
            communityInfo: `chapter/${[storeGetters.communityInfo]}`,
            selectedNetwork: `network/${storeGetters.getSelectedNetwork}`,
            connectPlusRedirects: `connectPlus/${storeGetters.connectPlusRedirects}`,
        }),
        currentNetwork: {
            get() {
                return this.selectedNetwork;
            },
            set(val) {
                this.setSelectedNetwork(val);
            },
        },
        isMember() {
            return (
                this.usersCommunitiesList &&
                this.$route &&
                this.$route.params.communityId &&
                this.usersCommunitiesList.some(u => u.communityId === this.$route.params.communityId)
            );
        },
        isAllNetworks() {
            return (
                this.usersCommunitiesList &&
                this.$route &&
                this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE)
            );
        },
        postImageFileSize() {
            return this.files.reduce((size, file) => {
                return size + file.size;
            }, 0);
        },
        alreadyUploadedFilesSize() {
            let bytes = this.attachments.reduce((size, file) => {
                return size + file.size;
            }, 0);
            bytes += this.postImageFileSize;
            return bytes;
        },
        placeholderType() {
            let communityName = '';
            if (!this.showCommentPlaceholder) {
                if (this.$route && this.$route.name && this.$route.name.toLowerCase() === routerNames.HOME.toLowerCase()) {
                    return communityCommonConstant.post.YOUR_FOLLOWERS;
                }
                if (this.communityInfo && this.communityInfo.name) {
                    communityName = this.communityInfo.name;
                }
            }
            return communityName;
        },
        addPostAction() {
            return this.actions[storeAction.createActivityPost || storeAction.uploadFilesToTemporaryStorage];
        },
        showPhotoUploader() {
            return this.files && this.files.length < communityCommonConstant.post.MAXIMUM_NUMBER_OF_POST_IMAGE;
        },
        isModeratedNetwork() {
            return (
                this.$route &&
                this.$route.name &&
                this.$route.name.toLowerCase() === routerNames.NETWORK.toLowerCase() &&
                this.usersCommunitiesList &&
                this.usersCommunitiesList.find(o => o.communityId === this.$route.params.communityId) &&
                this.usersCommunitiesList.find(o => o.communityId === this.$route.params.communityId)
                    .isActivityModerated === true
            );
        },
        showSharePost() {
            return (
                (this.$route.name && this.$route.name.toLowerCase() === routerNames.HOME.toLowerCase()) ||
                (this.communityInfo &&
                    this.communityInfo.communityId === this.$route.params.communityId &&
                    this.communityInfo.userAccess &&
                    this.communityInfo.userAccess.canSharePost)
            );
        },
        isNetworkPage() {
            return this.$route.name === routerNames.NETWORK;
        },
    },
};
</script>

<style lang="scss">
@import '../../../common/styles/_colors.scss';
@import '../../../common/styles/_responsive.scss';

@include breakpoint(xs) {
    .cke_contents {
        height: 250px !important;
        overflow-y: scroll !important;
    }
    .dialog-box {
        .cke_contents {
            height: 300px !important;
        }
    }
    .post {
        box-shadow: none !important;
        .file-attachment {
            border-top: 1px solid $ypo-medium-gray;
        }
    }
}

textarea {
    border-color: $ypo-medium-gray;
}

.disable_div {
    pointer-events: none;
    opacity: 0.5;
}

.post {
    min-height: 56px;
    border-radius: 4px;
    background-color: $white;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
    border: 1px solid rgba($ypo-gray, 0.4);
    box-shadow: 0 1px 3px 0 rgba($black, 0.18);

    &__header {
        display: flex;
        z-index: 9;
    }

    &__avatar {
        padding: 5px 0 5px 5px;
    }

    &__content {
        border-top: 1px solid rgba($ypo-gray, 0.4);
        padding: 10px 10px 5px 10px;
        width: 100%;
    }
    .content-message {
        background-color: $ypo-blue-tertiary;
        color: $white;
        padding: 12px 15px;
        border-radius: 4px;
        font-size: 14px;
        display: flex;
        align-items: flex-start;
        gap: 8px;
        line-height: 1.4;
        border: 2px solid $black;

        @include breakpoint(xs) {
            padding: 4px 5px;
            font-size: 11px;
        }

        &__icon {
            background-color: $white;
            color: $ypo-blue-secondary;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 8px;
            flex-shrink: 0;
            margin-top: 4px;
        }

        &__text {
            flex: 1;
        }

        &__link {
            color: $white;
            text-decoration: underline;
            cursor: pointer;
            pointer-events: auto;
            z-index: 1;
        }
    }


    &__file-upload {
        margin-left: 10px;
        margin-top: 5px;
        padding: 5px 15px !important;

        * {
            cursor: pointer !important;
        }

        &:hover {
            background-color: $ypo-open-blue-gray !important;
        }
    }

    &__POSTButton {
        min-height: 36px !important;
        min-width: 75px !important;
        border: 1px solid rgba($black, 0.12) !important;
        border-radius: 4px !important;
        background-color: $ypo_gray !important;
        color: $white !important;

        font-size: 11.55px !important;
        font-weight: bold !important;
        letter-spacing: 2.5px !important;
        line-height: 16px !important;
        text-align: center !important;
    }

    &__photoIcon {
        height: 15px !important;
        width: 15px !important;
    }

    &__placeholder {
        padding: 15px;
        font-size: 14px;
        letter-spacing: 0.46px;
        line-height: 20px;
        color: $ypo-gray-text;

        em {
            font-style: normal;
            text-transform: capitalize;
        }
    }

    &__BodyText {
        width: 100%;
        font-size: 13.55px;

        .v-input__slot {
            border: none !important;
            padding-left: 10px !important;
            min-height: inherit;
        }

        .v-avatar {
            position: absolute;
            left: 15px;
            top: 10px;
            cursor: default;
            z-index: 1;
        }

        textarea {
            font-size: 14px;
            height: 100px;
            margin: 15px 4px 0 70px !important;
            resize: none;
        }

        .v-text-field__details {
            display: none;
        }

        .cke_chrome {
            border: none;

            p {
                margin: 0 !important;
            }
        }

        .cke_top {
            border: none;
        }

        .cke_bottom {
            display: none;
        }

        .cke_editable {
            display: inline;
        }
    }

    &__image_sty {
        max-width: 100%;
        height: 50px;
    }

    &__error {
        color: $white;
        font-size: 12px;
    }

    &__img {
        text-align: center;
        position: relative;
        border-top: 1px solid $ypo-medium-gray;
        padding: 10px 0;

        .closeBtn {
            position: absolute !important;
            top: 0px;
            right: -3px;
            width: 24px;
            height: 24px;
            background: transparent !important;
            box-shadow: none !important;
            opacity: 0.5;

            &:hover {
                background: $white !important;
                opacity: 0.8;
            }
        }
    }

    &__Allow_Comments {
        color: $ypo-dark-gray;
        font-size: 16px;

        border-top: 1px solid $ypo-light-gray-background;
        padding: 5px 0 0px 0px;

        &__check {
            display: inline-block;
            position: relative;
            top: 6px;
            margin-right: 10px;
        }

        .v-label {
            font-weight: normal !important;
            font-size: 12px !important;
        }

        .btns_block {
            // margin-top: 10px;

            .v-btn {
                text-transform: inherit;
            }
        }
    }

    &__progress {
        position: absolute;
        left: 0;
        text-align: center;
        width: 100%;
        height: calc(100% - 20px);
        background: rgba($white, 0.5);
        z-index: 2;

        .v-progress-circular {
            top: 50%;
            margin-top: -16px;
        }
    }
}

.network-post {
    .flex {
        flex: 0 1 auto !important;
    }
}

.post-expand-block {
    &:before {
        //  content: '';
        width: 100%;
        height: 100%;
        position: fixed;
        background: rgba($black, 0.05);
        top: 0;
        left: 0;
        z-index: 7;
    }

    &-details {
        //  z-index: 100;
        position: relative;
        background: $white;
        border-radius: 3px;
        z-index: 5;
    }

    &-close {
        position: absolute !important;
        right: -10px;
        top: -10px;
        cursor: pointer;
        z-index: 1;

        .v-icon {
            font-size: 18px;
        }
    }

    &.post-block-error {
        border: 1px $ypo-error-red solid;
    }

    &__post-title {
        .v-input {
            position: relative;
            z-index: 9999;
            background: #fff;
            padding: 5px 20px;

            .v-input__control {
                min-height: 40px;
            }

            .v-input__slot {
                box-shadow: none !important;
                margin-bottom: 0;
                background: inherit !important;
                padding-left: 0 !important;
                font-size: 14px;
            }

            .v-label {
                font-size: 14px;
                font-weight: 500;
            }

            .v-text-field__details {
                display: none;
            }
        }
    }
}

.post_activation_expand_div {
    position: relative;
    z-index: 3;

    &::before {
        content: '';
        width: 100%;
        height: 100%;
        background: rgba($black, 0.02);
        position: fixed;
        z-index: 100;
        left: 0;
        top: 0;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}

.v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.v-input--selection-controls .v-input__slot {
    margin-bottom: 0;
}

@media (max-width: 767px) {
    .post__placeholder {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        display: block;
        padding-right: 70px;
    }

    .share__post {
        color: $white;
        background: $ypo_blue;
        position: absolute;
        right: 0;
        padding: 13px 17px;
        font-size: 20px;
        border-radius: 0 4px 4px 0;
    }
}

@media (max-width: 767px) {
    .post {
        .photo-uploader__btn {
            font-size: 12px;
            top: 0px;
            padding: 4px 10px;

            .v-icon {
                display: none;
            }
        }

        &__Allow_Comments {
            .v-btn {
                font-size: 12px;
                padding: 5px 10px !important;
            }
        }
    }
}</style
><style lang="scss">
@import '../../../common/styles/_colors.scss';

.network-selector {
    font-size: 14px;

    .v-select {
        &__selection {
            color: $ypo-blue;
            margin-bottom: 2px;
        }

        &__selections {
            color: $ypo-blue;
            margin-bottom: 2px;

            input {
                padding-bottom: 2px !important;
            }
        }
    }
}
</style>
